module.exports = __webpack_public_path__ + "media/images/emblems/Leissigen-coat_of_arms-7c318b17f6523a595aba8cb9057c8729.svg";